/**
 * Created by dongruihe on 2017/3/13.
 */
let util = require('../util.js');
// import { useragent } from "@xhtech/lux";
// import interceptor from '../interceptors';
// interceptor();

import { encrypter, decrypter } from "../jwe";
Vue.use(require('vue-resource'));
let ajax = module.exports;
let base = GLOBAL_URL.ROOT;

console.log('base1:', base)
const isPrd = env.env === 'uat' || env.env === 'production'
// const isPrd = true

//base = 'http://10.3.208.85:8080'
function ajaxFail(vm,response,error) {
    // 关闭loading
    if (response.status===403){
        let href = window.location.href
        let loginTem = ''
        let url = ''
        if(href.indexOf('share/lead.html') >= 0 || href.indexOf('lottery') >= 0) {
            //loginTem = 'share';
            //url ="/h5/login?view="+loginTem+"&redirect=";
            vm.isLogin = false;
            util.closeLoading();
            return;
        }else {
            loginTem = 'changecard';
          let isH5ProApi = response.url.indexOf('/h5pro-api/') > -1
          let isCouponApi = response.url.indexOf('/h5api/couponapi') > -1
          let isMarketApi = response.url.indexOf('/h5api/marketapi') > -1
          // const loginUrl = encodeURIComponent(window.location.origin + '/client/login.html')
          const redirect = encodeURIComponent(window.location.href)
          console.log('util.isAddGw()',util.isAddGw());
            if(isH5ProApi){
              if(util.isAddGw()){
                url = `/gw/h5pro-api/login?view=apply_p&redirect=${redirect}&appChannel=&isGateway=true`
              }else{
                url = `/h5pro-api/login?view=apply_p&redirect=${redirect}&appChannel=`
              }  
            } else if (isCouponApi || isMarketApi) {
              if(util.isAddGw()){
                url = `/gw/h5api/login?view=${loginTem}&redirect=${redirect}&isGateway=true`
              }else{
                url = `/h5api/login?view=${loginTem}&redirect=${redirect}`
              } 
            } else {
              if(util.isAddGw()){
                url =`/gw/h5-loan/h5login?view=${loginTem}&redirect=${redirect}&isGateway=true`
              }else{
                url =`/h5-loan/h5login?view=${loginTem}&redirect=${redirect}`
              }
                
            }
        }
        // url += encodeURIComponent(href);
        window.location.href=`${base}`+url;
        return;
    } else if(response.status===404) {
        util.closeLoading();
        vm.failureState={
            show:true
        };
    } else {
        util.closeLoading();
    }
    //响应错误响应
    if (typeof error  == 'function' && error != null){
        util.closeLoading();
        error(response);
        vm.failureState={
            show:true
        };
    }
}

ajax.get=function (vm,url,params,success,error) {
    if(!params.hideLoading) {
        util.showLoading();
    }
    let newUrl  =  base+url
    if (util.isAddGw()) {
       newUrl = base+'/gw'+url
    }

    Vue.http.get(newUrl,params).then(function (response) {
        // 关闭loading
        util.closeLoading();
        //响应正确响应
        if (typeof success  == 'function' && success != null){
            try {
                success(JSON.parse(response.body));
            } catch (error) {
                console.error('请求响应格式错误：'+ error + response)
            }
        }
    },function (response) {
        ajaxFail(vm,response,error);
    });
};

ajax.post=function (vm,url,params,success,error) {
    if(!params.hideLoading) {
        util.showLoading();
    }
    let newUrl = base+ url
    if (util.isAddGw()) {
      newUrl = base+'/gw'+url
    }

    Vue.http.post(newUrl,params).then(function (response) {
        // 关闭loading
        util.closeLoading();
        //响应正确响应
      if (typeof success == 'function' && success != null) {
          try {
            //   success(JSON.parse(response.body));
            if (response.data && typeof response.data == "string" && isPrd) {
                decrypter(response.data).then(function(decryptData){
                    if(decryptData.result){
                        response.data = JSON.parse(decryptData.data);
                        success(response.data);
                        return
                    }
                    response.body = JSON.parse(response.body);
                    success(response.body)
                })
            }else{
              success(JSON.parse(response.body));
            }
          } catch (error) {
              console.error('请求响应格式错误：' + error + response)
          }
      }
    },function (response) {
        if (response.data && typeof response.data == "string" && isPrd) {
            decrypter(response.data).then(function(decryptData){
                if(decryptData.result){
                    response.data = JSON.parse(decryptData.data);
                    ajaxFail(vm, response, error);
                    return
                }
                response.data = JSON.parse(response.data);
                ajaxFail(vm, response, error);
            })
        } else {
            ajaxFail(vm, response, error);
        }
    });
};
ajax.toPost=function (obj) {
    /*vm,url,params,headers,success,error*/
    util.showLoading();
    var vuegetsend=obj.headers ? {headers:obj.headers} : {};

    var newUrl = base+obj.url

    if(util.isAddGw()){
      newUrl = base+'/gw'+obj.url
    }

    Vue.http.post(newUrl,obj.params,vuegetsend).then(function (response) {
        // 关闭loading
        util.closeLoading();
        //响应正确响应
        if (typeof obj.success  == 'function' && obj.success != null){
            // if(response.data){
            //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
            // }
            // obj.success(response);
            if (response.data && typeof response.data == "string" && isPrd) {
                decrypter(response.data).then(function(decryptData){
                    if(decryptData.result){
                        response.data = JSON.parse(decryptData.data);
                        obj.success(response)
                        return
                    }
                    response.data = JSON.parse(response.data);
                    obj.success(response)
                })
            } else {
                obj.success(response);
            }
        }
    },function (response) {
        // if(response.data){
        //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
        // }
        // ajaxFail(obj.vm,response,obj.error);
        if (response.data && typeof response.data == "string" && isPrd) {
            decrypter(response.data).then(function(decryptData){
                if(decryptData.result){
                    response.data = JSON.parse(decryptData.data);
                    ajaxFail(obj.vm, response, obj.error)
                    return
                }
                response.data = JSON.parse(response.data);
                ajaxFail(obj.vm, response, obj.error)
            })
        } else {
            ajaxFail(obj.vm, response, obj.error);
        }
    });
};

ajax.newPost=function (obj) {
    /*vm,url,params,headers,success,error*/
    util.showLoading();
    var vuegetsend=obj.headers ? {headers:obj.headers} : {};
    var newUrl = base+obj.url
    if(util.isAddGw()){
      newUrl = base+'/gw'+obj.url
    }

    Vue.http.post(newUrl,obj.params,vuegetsend).then(function (response) {
        // 关闭loading
        util.closeLoading();
        //响应正确响应
        if (typeof obj.success  == 'function' && obj.success != null){
            if (response.data && typeof response.data == "string" && isPrd) {
                decrypter(response.data).then(function(decryptData){
                    if(decryptData.result){
                        response.data = JSON.parse(decryptData.data);
                        obj.success(response)
                        return
                    }
                    response.data = JSON.parse(response.data);
                    obj.success(response)
                })
            } else {
                obj.success(response);
            }
        }
    },function (response) {
        if (response.data && typeof response.data == "string" && isPrd) {
            decrypter(response.data).then(function(decryptData){
                if(decryptData.result){
                    response.data = JSON.parse(decryptData.data);
                    obj.error(response)
                    return
                }
                response.data = JSON.parse(response.data);
                obj.error(response)
            })
        } else {
            obj.error(response)
        }
    });
};

ajax.postPromise=function (url, params) {
    util.showLoading();
    return new Promise(function(resolve,reject){
        let newUrl = base+url
        if(util.isAddGw()){
          newUrl = base+'/gw'+url
        }

        Vue.http.post(newUrl,params).then(function (response) {
            // 关闭loading
            util.closeLoading();
            //响应正确响应
            if (typeof obj.success  == 'function' && obj.success != null){
                if (response.data && typeof response.data == "string" && isPrd) {
                    decrypter(response.data).then(function(decryptData){
                        if(decryptData.result){
                            response.data = JSON.parse(decryptData.data);
                            resolve(response)
                            return
                        }
                        response.data = JSON.parse(response.data);
                        resolve(response)
                    })
                } else {
                    resolve(response);
                }
            }
        },function (response) {
            if (response.data && typeof response.data == "string" && isPrd) {
                decrypter(response.data).then(function(decryptData){
                    if(decryptData.result){
                        response.data = JSON.parse(decryptData.data);
                        reject(response)
                        return
                    }
                    response.data = reject(response.data);
                    reject(response)
                })
            } else {
                reject(response)
            }
        });
    })
};

Vue.http.interceptors.push((request, next) => { 
  const newApi = util.isAddGw() ? request.url.split('/')[2]: request.url.split('/')[1]
    if (
      request.method == 'post' &&
      // request.body && 
      request.url.indexOf('/xwd-api/') === -1 && 
      request.url.indexOf('/auth/') === -1 && 
      request.url.indexOf('/gondarfront-in/') === -1 &&
      request.url.indexOf('/weixinh5/') === -1 &&
      // Object.keys(request.body).length > 0 && 
      isPrd
    ) {
      encrypter({
        kid: newApi || '',
        plaintext: JSON.stringify(request.body)
      }).then(function(encryptData){
        if (encryptData.result) {
          request.body = encryptData.data
          request.headers['jose'] = 'Y'
          request.headers['Content-Type'] = 'application/json'
        }
        next((response) => {
        //   if (response.data && typeof response.data == "string") {
        //     decrypter(response.data).then(function(decryptData){
        //       if(decryptData.result){
        //         response.body = decryptData.data;
        //         return response
        //       }
        //       return response
        //     })
        //   }else{
        //     return response;
        //   }
          return response;
        });
      })
    }else{
        next((response) => {
          return response;
        });
    }
  })



// WEBPACK FOOTER //
// ./web/js/common/ajax/ajax.js